import { makeStyles, tokens } from '@fluentui/react-components';

export const useConversationsNotesDialogStyles = makeStyles({
    embedded: {
        boxSizing: 'border-box',
        padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalL}`,
        width: '100%',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalL,
        maxHeight: '70vh',
        marginTop: tokens.spacingVerticalM,
        overflow: 'hidden',
        width: '100%',
    },
    notesList: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
        listStyleType: 'none',
        margin: 0,
        maxHeight: '55vh',
        minHeight: 0,
        overflowY: 'auto',
        padding: 0,
    },
    noteCard: {
        borderLeft: `3px solid ${tokens.colorBrandForeground1}`,
        padding: tokens.spacingVerticalM,
    },
    noteHeader: {
        alignItems: 'center',
        display: 'flex',
        gap: tokens.spacingHorizontalS,
    },
    noteBody: {
        color: tokens.colorNeutralForeground1,
        lineHeight: tokens.lineHeightBase400,
        marginTop: tokens.spacingVerticalM,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
    },
    emptyState: {
        alignItems: 'center',
        backgroundColor: tokens.colorNeutralBackground3,
        borderRadius: tokens.borderRadiusMedium,
        color: tokens.colorNeutralForeground2,
        display: 'flex',
        justifyContent: 'center',
        minHeight: '80px',
        padding: tokens.spacingVerticalL,
        textAlign: 'center',
    },
    addNote: {
        borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
        flexShrink: 0,
        paddingTop: tokens.spacingVerticalL,
    },
    actions: {
        marginTop: tokens.spacingVerticalM,
    },
    characterCount: {
        color: tokens.colorNeutralForeground3,
        display: 'block',
        marginTop: tokens.spacingVerticalXS,
        textAlign: 'right',
    },
});
